import { render, staticRenderFns } from "./StatusChanger.vue?vue&type=template&id=0f6c787e&scoped=true"
import script from "./StatusChanger.vue?vue&type=script&lang=js"
export * from "./StatusChanger.vue?vue&type=script&lang=js"
import style0 from "./StatusChanger.vue?vue&type=style&index=0&id=0f6c787e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c787e",
  null
  
)

export default component.exports